import axiosInstance from "./axiosInstance";

const pnlService = {
    fetchMedicinebyMonth: async () => {
        try {
            const response = await axiosInstance.get('/pnl/medicine');
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    fetchCheckupbyMonth: async () => {
        try {
            const response = await axiosInstance.get('/pnl/checkup');
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    fetchServicesbyMonth: async () => {
        try {
            const response = await axiosInstance.get('/pnl/services');
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
    fetchPharmacybyMonth: async () => {
        try {
            const response = await axiosInstance.get('/pnl/pharmacy');
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    fetchDailyRadiologyStats: async () => {
        const response = await axiosInstance.get(
            "/sales/daily-radiology-stats"
        );
        return response.data;
    },

    fetchDailyLaboratoryStats: async () => {
        const response = await axiosInstance.get(
            "/sales/daily-lab-stats"
        );
        return response.data;
    },

};

export default pnlService;
